import {
  PersonProjectsTableStore,
  PERSON_PROJECTS_TABLE_STORE
} from 'store'

export type ProjectsSectionProps = {
  [PERSON_PROJECTS_TABLE_STORE]?: PersonProjectsTableStore
}

// export const personProjectsTableWidths = {
//   name: 32,
//   type: 14,
//   role: 16,
//   genre: 18,
//   published: 20
// }
export const personProjectsTableWidths = {
  name: 570,
  type: 200,
  role: 300,
  genre: 300,
  published: 382
}
